module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"first_name":"First name","last_name":"Last name","email":"Email","phone":"Phone","cancel":"Cancel","confirm":"Confirm"},"fr":{"first_name":"Prénom","last_name":"Nom","email":"Email","phone":"Téléphone","cancel":"Annuler","confirm":"Confirmer"},"de":{"first_name":"Vorname","last_name":"Name","email":"Email","phone":"Telefon","cancel":"Stornieren","confirm":"Bestätigen"}}')
  delete Component.options._Ctor
}
